import { useRouter } from "next/router"

import Gtm from "lib/gtm"
import { useTranslation } from "lib/i18n/translation"

import Page from "components/tops/page"

const Tops = ({ tops }) => {
	const router = useRouter()
	const url = router ? router.asPath : null
	const { c } = useTranslation("common")

	return (
		<>
			<Gtm pageType="Tops des listes" pagePath={url} pageTitle={c("most-quoted-films")} />
			<Page tops={tops} />
		</>
	)
}

export const getInitialProps = async (ctx) => {
	const domain = ctx.req ? `${ctx.req.protocol}://${ctx.req.get("Host")}` : ""
	const tops = await fetch(`${domain}/fetch-tops`).then(res => res.json())

	return {
		...tops
	}
}

Tops.getInitialProps = getInitialProps

export default Tops
